module.exports = __webpack_public_path__ + "assets/e422841f50787b82f5596a37e7c86e53.png";